var n="aptos:signAndSubmitTransaction";export{n as a};
//# sourceMappingURL=chunk-PFWJQYHN.mjs.map